import React from 'react';
import { Icon } from '@iconify/react';

const UserDropdown = ({
  user = {
    name: 'Amit Kumar',
    role: 'Admin',
    avatar: 'assets/images/user.png',
  },
  menuItems = [
    { label: 'My Profile', icon: 'solar:user-linear', href: 'view-profile.html' },
    { label: 'Inbox', icon: 'tabler:message-check', href: 'email.html' },
    { label: 'Setting', icon: 'icon-park-outline:setting-two', href: 'company.html' },
    { label: 'Log Out', icon: 'lucide:power', href: '/', danger: true },
  ],
  onClose = () => {},
}) => {
  return (
    <div className="dropdown">
      <button
        className="d-flex justify-content-center align-items-center rounded-circle"
        type="button"
        data-bs-toggle="dropdown"
      >
        <img
          src={user.avatar}
          alt="User"
          className="w-40-px h-40-px object-fit-cover rounded-circle"
        />
      </button>
      <div className="dropdown-menu to-top dropdown-menu-sm">
        <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
          <div>
            <h6 className="text-lg text-primary-light fw-semibold mb-2">
              {user.name}
            </h6>
            <span className="text-secondary-light fw-medium text-sm">
              {user.role}
            </span>
          </div>
          <button type="button" className="hover-text-danger" onClick={onClose}>
            <Icon icon="radix-icons:cross-1" className="icon text-xl" />
          </button>
        </div>
        <ul className="to-top-list">
          {menuItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                className={`dropdown-item text-black px-0 py-8 hover-bg-transparent ${
                  item.danger ? 'hover-text-danger' : 'hover-text-primary'
                } d-flex align-items-center gap-3`}
              >
                <Icon icon={item.icon} className="icon text-xl" />
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserDropdown;
